module.exports = __webpack_public_path__ + "img/kenya.6b62499d.svg";